(() => {
  const root = document.getElementById('mavericks-verify');
  if (!root) return;
  const $ = (id) => document.getElementById(id);
  const pt = (root.dataset.language || '').toLowerCase().startsWith('pt');
  const copy = pt ? {
    serial: 'Número de série', verify: 'Consultar', code: 'Código de verificação', verifyCode: 'Verificar código', hint: 'A verificação bem-sucedida usa este código uma única vez.',
    loading: 'Consultando o número de série…', checking: 'Verificando o código…', invalid: 'Número de série não encontrado.', badCode: 'Código inválido. Confira e tente novamente.', success: 'Produto autêntico. Código verificado.', used: 'Este número de série já foi verificado. Entre em contato com o suporte se isso for inesperado.', unavailable: 'O serviço de verificação está indisponível. Tente novamente mais tarde.'
  } : {
    serial: 'Serial number', verify: 'Verify', code: 'Verification code', verifyCode: 'Verify code', hint: 'A successful verification uses this code once.',
    loading: 'Looking up serial number…', checking: 'Checking verification code…', invalid: 'Serial number not found.', badCode: 'Invalid code. Check it and try again.', success: 'Authentic product. Code verified.', used: 'This serial has already been verified. Contact support if this is unexpected.', unavailable: 'Verification is unavailable. Please try again later.'
  };
  const serialForm = $('mavericks-serial-form');
  const codeForm = $('mavericks-code-form');
  const serialInput = $('mavericks-serial');
  const codeInput = $('mavericks-code');
  const serialStatus = $('mavericks-verify-status');
  const codeStatus = $('mavericks-code-status');
  const product = $('mavericks-product');
  const warning = $('mavericks-warning');
  let currentSerial = '';
  serialForm.querySelector('label').textContent = copy.serial;
  serialForm.querySelector('button').textContent = copy.verify;
  codeForm.querySelector('label').textContent = copy.code;
  codeForm.querySelector('button').textContent = copy.verifyCode;
  codeForm.querySelector('.mv-hint').textContent = copy.hint;
  const status = (el, message, kind = '') => { el.textContent = message; el.className = kind ? `mv-${kind}` : ''; };
  const endpoint = (serial) => `https://api-server-production-813e.up.railway.app/api/mavericks/verify/${encodeURIComponent(serial)}`;
  const errorMessage = (data, fallback) => {
    const code = data?.error?.code;
    if (code === 'INVALID_SERIAL') return copy.invalid;
    if (code === 'INVALID_CODE') return copy.badCode;
    return fallback;
  };
  const plainDescription = (value) => typeof value === 'string' ? value
    .replace(/\[!\[[^\]]*\]\([^)]*\)\]\([^)]*\)/g, '')
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/^\s*#{1,6}\s*/gm, '')
    .replace(/\*\*|__/g, '')
    .replace(/^\s*[-*]\s+/gm, '• ')
    .replace(/\n{3,}/g, '\n\n')
    .trim() : '';
  serialForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    const serial = serialInput.value.trim().toUpperCase();
    product.hidden = true;
    currentSerial = '';
    status(codeStatus, '');
    if (!/^[A-Z0-9_-]{3,80}$/.test(serial)) return status(serialStatus, copy.invalid, 'error');
    const button = serialForm.querySelector('button'); button.disabled = true;
    status(serialStatus, copy.loading);
    try {
      const response = await fetch(endpoint(serial), { cache: 'no-store' });
      const data = await response.json();
      if (!response.ok || data.error) return status(serialStatus, errorMessage(data, copy.unavailable), 'error');
      currentSerial = serial;
      $('mavericks-brand').textContent = data.brandName || '';
      $('mavericks-name').textContent = data.name || serial;
      $('mavericks-details').textContent = [data.quantity, serial].filter(Boolean).join(' · ');
      const photo = $('mavericks-photo');
      const url = Array.isArray(data.photos) ? data.photos[0] : null;
      if (url && /^https:\/\//.test(url)) { photo.src = url; photo.hidden = false; } else { photo.removeAttribute('src'); photo.hidden = true; }
      const description = $('mavericks-description');
      description.textContent = plainDescription(data.description);
      description.hidden = !description.textContent;
      const coa = $('mavericks-coa');
      if (typeof data.coaFile === 'string' && /^https:\/\//.test(data.coaFile)) { coa.href = data.coaFile; coa.hidden = false; } else { coa.removeAttribute('href'); coa.hidden = true; }
      coa.textContent = pt ? 'Certificado de análise' : 'Certificate of analysis';
      warning.hidden = !data.warnings?.alreadyVerified?.verificationCount;
      warning.textContent = warning.hidden ? '' : copy.used;
      codeForm.hidden = data.verifiable === false;
      product.hidden = false;
      status(serialStatus, '');
    } catch { status(serialStatus, copy.unavailable, 'error'); }
    finally { button.disabled = false; }
  });
  codeForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!currentSerial) return;
    const code = codeInput.value.trim().toUpperCase();
    if (!/^[A-Z0-9]{4,20}$/.test(code)) return status(codeStatus, copy.badCode, 'error');
    const button = codeForm.querySelector('button'); button.disabled = true;
    status(codeStatus, copy.checking);
    try {
      const response = await fetch(endpoint(currentSerial), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code }) });
      const data = await response.json();
      if (data.valid) { status(codeStatus, copy.success, 'success'); codeForm.hidden = true; }
      else status(codeStatus, errorMessage(data, copy.badCode), 'error');
    } catch { status(codeStatus, copy.unavailable, 'error'); }
    finally { button.disabled = false; }
  });
  const initial = new URLSearchParams(window.location.search).get('serial');
  if (initial) { serialInput.value = initial; serialForm.requestSubmit(); }
})();
